import React from 'react'
import { Image } from 'react-bootstrap';

const Avatar = ({ src, size = '50', alt = '', onClick }) => {
    const avatarStyle = {
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '50%',
        border: '2px solid #FF8934',
        padding: '1px',
    };
    return (
        <>
            {src ? <Image src={src} alt={alt} style={avatarStyle} onClick={onClick} /> :
                <div style={{ ...avatarStyle, display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#FF8934', fontSize: '28px' }} onClick={onClick}>
                    <i className="bi bi-plus-lg"></i>
                </div>
            }

        </>
    )
}

export default Avatar